import gql from 'graphql-tag'

export const CreateLoanApplication = gql`
    mutation CreateLoanApplication(
        $loan_application: InputLoanApplicationFromNode!
    ) {
        createLoanApplicationInNode(loan_application: $loan_application) {
            data {
                loan_application_id
            }
        }
    }
`

export const GetPreQualificationData = gql`
    query getPreQualificationData {
        getPreQualificationData {
            totalNetWorth
            totalDebt
            totalCryptoWorth
            monthlyIncome
            freeCashFlow
            debtToIncomeRatio
            preQualified
            totalAssets
        }
    }
`

export const UpdateLoanApplication = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput) {
        updateUserProfile(input: $input) {
            id
            email
            firstName
            lastName
            phone
            dateOfBirth
            loanApplicationId
            countryId
            lastLoginDate
            givenConsentDate
            removedConsentDate
            notifyEmail
            notifyPhone
            payableAddress
            loanApplicationId
        }
    }
`

export const GetLoan = gql`
    query getLoanApplication($id: String!) {
        getOneLoanApplicationFromNode(id: $id) {
            data {
                data {
                    amount
                    date
                    fees
                    interest_rate
                    interest
                    term
                    principal
                    prequalification_amount
                    ltv_ratio
                    last_updated
                    iso_currency_code
                }
                name
                loan_product
                loan_application_id
                institution_id
                loan_purpose
                status
            }
        }
    }
`
